import React from "react";
import Dialog from "@material-ui/core/Dialog";
import FileUploader from "../../../common/fileUploader/fileUploader.js";
import FileDownload from "../../../common/fileDownload/fileDownload.js";
import whitelistedEmailsList from "../../creditLines/components/whitelistedEmailsForOperations.json";
export default class ResponsiveDialog extends React.Component {
    state = {
        open: false
    };

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        let restrictmailids = JSON.parse(localStorage.getItem("user"));
        let jumbotailUser = restrictmailids.userProfile.loginId.split('@');
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        let tenant_Id = restrictmailids.userProfile.tenantId;
        return (
            <div>

                {
                    tenant_Id == "TENANT-135108" && !whitelistedEmailsList["emailIds"].includes(loggedInUser.userProfile.loginId)
                    ?
                    " "
                    :
                    (
                        <button onClick={this.handleClickOpen} className="btn btn-jt-ops pull-right">
                            Upload Txn File
                        </button>
                    )
                }

                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="responsive-dialog-title"
                        maxWidth="lg">
                    <div>
                        <div style={{padding: "20px"}}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="pull-right" onClick={this.handleClose}
                                         style={{fontSize: "22px", cursor: "pointer"}}>
                                        <i class="fas fa-times"/>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Credit Transactions</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/credit_transactions"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/credit_transaction/bulk"/>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Payment Instrument Status</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/pi_status"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/credit_payment_instrument/bulk"/>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Repayment Received</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/credit_offline_transactions"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/offline_transaction/bulk"/>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Product Switch</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/product_switch"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/product_switch"/>
                                    </div>
                                </div>
                                <hr></hr>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">DPN Transactions</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/dpn"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/dpn"/>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Bank CMS</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/cms"/>
                                        </div>

                                        <FileUploader url="api/credit/gateway/ingest/cms/bulk"/>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="ingestionTitle">Due Date</div>
                                        <div className="formattor">
                                            <FileDownload title={"Download Format"}
                                                          url="api/credit/gateway/template/ingest/due_date"/>
                                        </div>
                                        <FileUploader url="api/credit/gateway/ingest/due_date/edit"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/creditTransactions/components/CreditTransactionsIngestion.js